/**
 * Reports a LinkedIn conversion event.
 * This function fires a conversion event for LinkedIn Insight Tag tracking.
 *
 * @returns void
 */
export function reportLinkedInConversion(): void {
  if (typeof window === 'undefined') return;

  // Check if lintrk is available
  if (typeof window.lintrk === 'undefined') {
    console.warn('[LinkedIn] lintrk not found. Conversion event not tracked.');
    return;
  }

  try {
    window.lintrk('track', { conversion_id: 26094569 });

    console.log('[LinkedIn] Conversion event fired');
  } catch (error) {
    console.error('[LinkedIn] Failed to fire conversion event:', error);
  }
}
